"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = Layout;
exports.Empty = Empty;

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _EmptyList = _interopRequireDefault(require("../Settings/components/EmptyList"));

function Layout(_ref) {
  var children = _ref.children,
      loading = _ref.loading;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var title = (0, _react.useMemo)(function () {
    return loading ? null : /*#__PURE__*/_react["default"].createElement("h1", {
      className: "mb-3 text-xl font-semibold text-dark"
    }, t('contactDetail.messages.title'));
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow flex flex-col"
  }, title, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow"
  }, children));
}

function Empty() {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_react["default"].createElement(_EmptyList["default"], {
    image: t('empty-settings-contacts.png'),
    title: t('settings.contacts.empty.title'),
    subtitle: t('settings.contacts.empty.subtitle')
  });
}
//# sourceMappingURL=Messages.js.map